const emailConfig = {
  SecureToken: process.env.REACT_APP_EMAIL_TOKEN,
  From: "you@isp.com",
  To: "them@website.com",
  Subject: "This is the subject",
  Body: "And this is the body",
};

const getEmailConfig = (from, to, subject, body) => {
  return {
    SecureToken: process.env.REACT_APP_EMAIL_TOKEN,
    From: from,
    To: to,
    Subject: subject,
    Body: body,
  };
};
export default getEmailConfig;
